import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function Minus($$anchor, $$props) {
	const iconNode = [["path", { "d": "M5 12h14" }]];
	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiTWludXMuc3ZlbHRlIl0sInNvdXJjZXNDb250ZW50IjpbIjxzY3JpcHQgbGFuZz1cInRzXCI+XG4gIGltcG9ydCBJY29uIGZyb20gJy4vSWNvbi5zdmVsdGUnO1xuICBjb25zdCBpY29uTm9kZTogW3N0cmluZywgUmVjb3JkPHN0cmluZywgc3RyaW5nPl1bXSA9IFtbXCJwYXRoXCIsIHsgXCJkXCI6IFwiTTUgMTJoMTRcIiB9XV07XG4gIGxldCByZXN0ID0gJHByb3BzKCk7XG48L3NjcmlwdD5cbjxJY29uIHtpY29uTm9kZX0gey4uLnJlc3R9IC8+XG4iXSwibWFwcGluZ3MiOiI7O09BQ1MsSUFBSSxNQUFNLGVBQWU7O2lEQURsQyxDQUFDO09BRU8sUUFBNEMsS0FBSyxNQUFNLElBQUksR0FBRyxFQUFFLFVBQVU7S0FDNUUsSUFBSTs7Ozs7Ozs7UUFFVyxJQUFJOztBQUQxQixDQUFDIn0=